import { get, put } from "services";
import routes from "./routes";

const AgentBotServices = {
  getAgentList: async (params) => {
    const data = await get(routes.getList, params);
    return data;
  },
  getAgentStatus: async (params) => {
    const data = await get(routes.getStatus, params);
    return data;
  },
  getPrepaidAgentStatus: async (params) => {
    const data = await get(routes.getPrepaidStatus, params);
    return data;
  },
  getPrepaidAgentList: async (params) => {
    const data = await get(routes.getPrepaidList, params);
    return data;
  },
  agentPermissionUpdate: async (payload) => {
    const data = await put(routes.agentPermission, payload);
    return data;
  },
};

export default AgentBotServices;
